<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    莲花村站<br>
站点介绍<br>
莲花村站位于深圳福田区红荔路与彩田路交叉路口处，沿红荔路东西向布置，地处莲花山东面。在车站A出口可以到达中银大厦、地铁大厦，在B出入口有福莲公园、现代演艺中心、紫玉花园、振业花园，在C出口有莲花大厦，可以直达莲花二村，在D出入口有著名的旅游景区关山月美术馆和莲花山公园，形成一道靓丽的风景线，“小荷才露尖尖角，地铁已过莲花村”，光绿色的车站色系使车站显得更加充满活力。莲花村站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:13	00:00	3号线	2分15-20秒	4分30秒<br>
双龙	06:30	23:13	3号线	2分15-20秒	4分30秒<br>
福田口岸	06:24	23:46	10号线	3分40秒	6分钟<br>
双拥街	06:22	23:09	10号线	3分40秒	6分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:20	00:00	3号线	3分15秒	5分钟<br>
双龙	06:31	23:12	3号线	3分15秒	5分钟<br>
福田口岸	06:29	23:46	10号线	4分50秒	7分钟<br>
双拥街	06:29	23:09	10号线	4分50秒	7分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
福保	06:20	01:00	3号线	3分15秒	5分钟<br>
双龙	06:31	00:12	3号线	3分15秒	5分钟<br>
福田口岸	06:25	00:46	10号线	4分50秒	7分钟<br>
双拥街	06:21	00:09	10号线	4分50秒	7分钟<br><br>
<br>
站点出口信息<br><br>
A1出入口:<br>
海田路(东)、地铁大厦<br><br>
A2出入口:<br>
彩田路西侧（南）、红荔路南侧（西）、中银花园、中银大厦、天健世纪花园、深业花园、深圳市天健小学<br><br>
B1出入口:<br>
彩田路（南）、莲花小学、莲花三村<br><br>
B2出入口:<br>
红荔路南侧（东）<br><br>
C1出入口:<br>
皇岗路（北）、彩田路东侧（北）、红荔路北侧（东）<br><br>
C2出入口:<br>
莲花二村、莲花大厦、深圳市莲花二村幼儿园、莲花中学（北校区）、美莲花园、美莲小学<br><br>
D出入口:<br>
红荔路（西）、彩田路（北）、莲花山公园<br><br>
E出入口:<br>
彩田路西侧（北）、红荔路北侧（西）<br><br>
公交换乘信息<br><br>
A1出入口:<br>
公交站名： 关山月美术馆②<br>
108路，10路，111路，14路，215路，64路，M555路<br><br>
A2出入口:<br>
公交站名： 莲花中学<br>
14路，M115路，M198路，M347路，M454路，M500路，高峰专线23号，高峰专线91号<br><br>
B1出入口:<br>
公交站名： 福景大厦<br>
14路，M115路，M198路，M329路，M347路，M389路，高峰专线23号，高峰专线91号，高快巴士27号<br><br>
B2出入口:<br>
公交站名： 莲花二村②<br>
75路,M173路,108路,10路,111路,215路,64路,M389路,M105路,M391路,M417路,高快巴士27号<br><br>
C1出入口:<br>
公交站名： 莲花二村②<br>
108路，10路，111路，215路，64路，75路，M105路，M173路，M389路，M417路，M391路,高快巴士27号<br><br>
C2出入口:<br>
公交站名： 莲花中学<br>
34路,M588路,67路,75路,M115路,M347路,M454路,M459路,M500路,14路,M198路,高峰专线23号，高峰专线91号<br><br>
D出入口:<br>
公交站名： 关山月美术馆①<br>
322路，34路，M105路，M173路，M391路,M183路，M262路，M417路，M459路，M588路，M488路，高快巴士18号，高快巴士19号<br><br>
D出入口:<br>
公交站名： E出入口<br>
无<br>
</nav>
</template>

<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "sanhaoxian",
          title: "3号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shihaoxian",
          title: "10号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>